'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedirectError = function (_Error) {
  _inherits(RedirectError, _Error);

  function RedirectError(message) {
    _classCallCheck(this, RedirectError);

    var _this = _possibleConstructorReturn(this, (RedirectError.__proto__ || Object.getPrototypeOf(RedirectError)).call(this, message || 'Rejecting because of redirect -- prevent promise until reload'));

    _this.name = 'RedirectError';
    return _this;
  }

  return RedirectError;
}(Error);

exports.default = RedirectError;
module.exports = exports['default'];